import React from "react";

import styles from "./TextArea.module.scss";
import block from 'bem-css-modules';
import { sanitizeContent as s } from "../../../../util/functions";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { IFieldProperties } from "../InputFields.types";

const TextArea = (props: { fieldData: IFieldProperties, register: UseFormRegister<any>, errors: FieldErrors }) => {
  const { 
    fieldData: {
      label,
      text,
      title,
      placeholder, 
      validationText,
      settings: [{
        crmProperty,
        required
      }]
    },
    register,
    errors
  } = props

  const b = block(styles);

  return (
    <div className={b()}>
      {title && (
        <h3 className={b("title")} dangerouslySetInnerHTML={{ __html: s(title) }}/>
      )}
      {text && <div className={b("text")} dangerouslySetInnerHTML={{ __html: s(text) }} />}
      <textarea
        id={label}
        data-crm-field={crmProperty}
        placeholder={placeholder}
        {...register(
          label,
          {
            required: required
          }
        )}
      />
      {errors[label] && (
        <div className={b("error")} dangerouslySetInnerHTML={{ __html: s(validationText) }} />
      )}
    </div>
  )
}

export default TextArea;